import { useRef, useState, useEffect } from "react";
// Importacion de las imagenes utilizadas para la brujula
import relojBase from "../../img/domo/Picture7.png";
import grua from "../../img/domo/grua-staker.png";
import gruaReclaimer from "../../img/domo/grua-reclaimer.png";
import AllVActualDomo from "../../components/Charts/Domo/AllVActualDomo";
// Importacion de lo estilos css
import "./Compass.css";

/**
 * 
 * @returns 
 */
export default function Compass() {
  const [staker, setStaker] = useState(0);
  const [reclaimer, setReclaimer] = useState(0);

  const manesilla = useRef(0);
  const imgReclaimer = useRef(0);
  useEffect(() => {
    const fetchData = async () => {
      const data = await AllVActualDomo.getAll();

      // Validar para el domo cuando no tenga datos

      if (data) {
        const stakerData = data.filter((x) => x.KPI === "Posición staker");

        if (stakerData.length === 0) {
          setReclaimer(0);
          setStaker(0);
          if(manesilla.current !== null){
            manesilla.current.style.transform = "rotate(0deg)";
          }
        } else {
          if (stakerData[0].Valor) {
            setStaker(stakerData[0].Valor);

            if (manesilla.current !== null) {
              for (let index = 0; index <= staker; index++) {
                manesilla.current.style.transform = "rotate(" + staker + "deg)";
              }
            }
          }

          const reclaimerData = data.filter(
            (x) => x.KPI === "Posición reclaimer"
          );

          if (reclaimerData[0].Valor) {
            setReclaimer(reclaimerData[0].Valor);
            if (imgReclaimer.current !== null) {
              for (let index = 0; index <= reclaimer; index++) {
                imgReclaimer.current.style.transform =
                  "rotate(" + reclaimer + "deg)";
              }
            }
          }
        }
      }
    };

    fetchData();
  }, [reclaimer, staker]);

  /*
  useEffect(() => {
    if (isCompassMoving) {
      window.addEventListener("mousemove", handleCompassMove);
    } else {
      window.removeEventListener("mousemove", handleCompassMove);
    }
    return () => window.removeEventListener("mousemove", handleCompassMove);
  }, [isCompassMoving, handleCompassMove]);
  */

  return (
    <>
      <div className="container-compass">
        <div className="main-compass">
          <img id="relojBase-compass" src={relojBase} alt="reloj-base" />
          <img
            id="lineaBase-compass"
            className="line"
            ref={manesilla}
            src={grua}
            alt="manesilla"
          />

          <img
            id="lineaBase-compass"
            className="line"
            ref={imgReclaimer}
            src={gruaReclaimer}
            alt="manesilla"
          />
        </div>
      </div>
    </>
  );
}
